import {
  compose,
  defaultTo,
  curry,
  flatten,
  map,
  prop,
  cond,
  F,
  T,
  includes,
  filter,
  ifElse,
  isEmpty,
  intersection,
  always,
  complement,
  not,
  __,
} from 'ramda'
import { safePropEq } from 'libs/ramdaExt'
import { isEmptyOrNil } from 'libs/empty'
import { EVERYONE, SUBSCRIBER_WITHOUT_GROUP } from 'app/constants/recipient'

export const getHomelessTagIds = curry((homelessGroupId, state) =>
  compose(
    defaultTo([]),
    flatten,
    map(compose(map(prop('id')), prop('tags'))),
    filter(safePropEq('id', homelessGroupId)),
    prop('groups'),
  )(state),
)
export const contains = (list) => (one) =>
  compose(
    cond([
      [isEmptyOrNil, F],
      [() => isEmptyOrNil(list), F],
      [T, includes(__, list)],
    ]),
  )(one)

export const ifSelectSpecialToEmpty = curry((homeLessTagIds, state) =>
  compose(
    defaultTo([]),
    ifElse(
      compose(not, isEmpty, intersection(homeLessTagIds)),
      always([]),
      filter(complement(contains(homeLessTagIds))),
    ),
    prop('selectedTags'),
  )(state),
)

export const handleOptionsOnlyGroups = (options = []) => {
  if (isEmptyOrNil(options)) return []

  const groups = []

  for (const item of options) {
    if ([EVERYONE, SUBSCRIBER_WITHOUT_GROUP].includes(item.type)) {
      continue
    } else {
      groups.push(item)
    }
  }
  return groups
}
